export default "<div class=\"scroll-to-top\" [ngClass]=\"{'show-scrollTop': onWindowScrolled}\">\n</div>\n"